import type { EventFilters } from "../types/eventFilters";

function toLocalDateString(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function getTodayRange(): { fromDate: string; toDate: string } {
    const today = toLocalDateString(new Date());
    return { fromDate: today, toDate: today };
}

/** Upcoming Saturday–Sunday (includes the current weekend if today is Sat or Sun). */
export function getThisWeekendRange(): { fromDate: string; toDate: string } {
    const now = new Date();
    const day = now.getDay();
    const saturday = new Date(now);
    const sunday = new Date(now);

    if (day === 0) {
        saturday.setDate(now.getDate() - 1);
        sunday.setDate(now.getDate());
    } else if (day === 6) {
        sunday.setDate(now.getDate() + 1);
    } else {
        const daysUntilSat = 6 - day;
        saturday.setDate(now.getDate() + daysUntilSat);
        sunday.setDate(saturday.getDate() + 1);
    }

    return {
        fromDate: toLocalDateString(saturday),
        toDate: toLocalDateString(sunday),
    };
}

export function isTodayFilter(filters: EventFilters): boolean {
    const { fromDate, toDate } = getTodayRange();
    return (
        filters.fromDate === fromDate &&
        filters.toDate === toDate &&
        filters.weekdays.length === 0
    );
}

export function isThisWeekendFilter(filters: EventFilters): boolean {
    const { fromDate, toDate } = getThisWeekendRange();
    return (
        filters.fromDate === fromDate &&
        filters.toDate === toDate &&
        filters.weekdays.length === 0
    );
}

export function applyTodayFilter(filters: EventFilters): EventFilters {
    const { fromDate, toDate } = getTodayRange();
    return { ...filters, fromDate, toDate, weekdays: [] };
}

export function applyThisWeekendFilter(filters: EventFilters): EventFilters {
    const { fromDate, toDate } = getThisWeekendRange();
    return { ...filters, fromDate, toDate, weekdays: [] };
}

export function clearDatePreset(filters: EventFilters): EventFilters {
    return { ...filters, fromDate: null, toDate: null };
}
